/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowAdventureParkVisitTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowAdventureParkVisit,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Have an Adventure!",
    "Adventure Park Awaits!",
    "Thrills and Fun!",
  ],
  title: "Adventure Park Visit",
  description: "Organize an exciting visit to an adventure park.",
  longDescription:
    "Gather your friends for a day of fun at the adventure park! Choose a date, decide on rides to enjoy, and plan activities for the day!",
  emoji: "🎢",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Adventure Park Visit",
          emoji: "🎢",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we visit the adventure park?",
          emoji: "📅",
          completeAction: {
            question: "Decide on rides to enjoy?",
            description: "What rides should we prioritize during our visit?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What rides should we choose?",
                emoji: "🎠",
                completeAction: {
                  question: "Decide on snacks?",
                  description: "What snacks should we enjoy during the visit?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍭",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Adventures Begin!",
    outroDescription:
      "Your adventure park visit plans are set! Enjoy the thrills!",
  },
};
